import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PlanList from "../../Components/PlanList";
import sal from "sal.js";
import AllFeatures from "../../Components/AllFeatures";
import { Helmet } from "@dr.pogodin/react-helmet";
import MinPlanPrice from "../../Components/MinPlanPrice";
import { ScrollToPlans } from "../../utils/ScrollToPlan";
import CouponScrollBar from "../../Components/CouponScrollBar";
import StreamingServerVideo from "../../Components/StreamingServerVideo";

export default function StreamingServerLondon() {
  const [applyPaddingClass, setApplyPaddingClass] = useState(false);
  useEffect(() => {
    document.title = "Streaming Server London for Smooth HD Video Streaming Pro";
          sal();
        }, []);
   const handlePlanClick = () => {
      ScrollToPlans(".price-plan-section");
    };
  return (
    <>
    <Helmet>
        <title>Streaming Server London for Smooth HD Video Streaming Pro</title>
        <meta name="description" content="Looking for a fast streaming server london? Enjoy low latency, premium network, high bandwidth aur secure streaming infrastructure worldwide today now!" />
        <meta name="keywords" content="Web Streaming Service, Streaming Server London, Personal Streaming Service, Best Streaming Server, Streaming Server Cost, Best Server For Streaming, Best Stream Server, Live Streaming Server, Open Streaming Server, Self Hosted Streaming, Server For Streaming Media, Server Streaming Open Source, Set Up A Streaming Server, Streaming Server Hosting Cost, Streaming Server Hosting, Media Streaming Server, Stream Server, Streaming Server Windows, Live Stream Server, Streaming Web Server, Web Server Streaming, Streaming-Server, Vod Server" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/streaming-server-london`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/streaming-server-london`} />
        <meta property="og:title" content="Premium Streaming Servers in London: High Media Quality" />
        <meta property="og:description" content="Engage the audience with highly demanded streaming servers in London, providing high-quality, buffer-free streaming for smooth live & VOD content delivery." />
    </Helmet>
    <section className="banner-bg bg-dark linux-reseller-banner">
      <div className="container">
        <div className="row align-items-center">
            <div className="col-lg-7 col-xl-6">
              <span className="fs-18 fw-semibold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Crown-Class Streaming</span>
              <h1 className="text-white mb-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Never Lose a Viewer With Our Streaming Server London</h1>
              <p className="mb-8 text-white max-text-72 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Imagine hitting play… & your screen shows that loading wheel. Feels irritating even in imagination. Your viewers won’t wait. But with the help of our streaming server London, your content loads in seconds and always keeps them coming back.</p>
              <div className="d-flex align-items-center gap-5 flex-wrap sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                  <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded sal-animate btn-height" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <span className="btn-arrow__text">
                        View All Plans
                        <span className="btn-arrow__icon">
                            <i className="fa-solid fa-arrow-right"></i>
                        </span>
                    </span>
                </button>
                <MinPlanPrice category="customizedssln" />
              </div>
              <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
            </div>
            <div className="col-lg-5 col-xl-6 text-lg-end ipad-mt">
              <img alt="image" className="img-fluid sal-animate full-width-img" data-sal="fade" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" src="/images/never-lose-a-viewer.webp" />
            </div>
        </div>
      </div>
    </section>

      <div className="pt-100 pb-100 linux-hosting-points-section">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center justify-content-xl-between">
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Thames Stream Flow
                        </small>
                        <h2 className="mb-4">
                            Streaming Server London for Important Moments
                        </h2>
                        <p className="max-text-56 mb-0 fw-semibold">
                            Need a powerful streaming solution that only works? Our live streaming server London offers seamless performance,
                            user-friendly controls, and 99.9% uptime-so you can go live anywhere without the stress.
                        </p>
                    </div>
                    <div className="col-lg-6 col-xl-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="card">
                            <div className="card-body">
                                <div className="features-video position-relative z-1"><img alt="image" className="img-fluid w-100" src="/images/streaming-server-yt-banner.jpg" /><Link to="#" className="btn gradient-bg w-15 h-15 d-grid place-content-center rounded-circle position-absolute top-50 start-50 translate-middle fs-24 text-white popup-init" data-bs-toggle="modal" data-bs-target="#streamingServerVideoModal"><i className="fa-solid fa-play"></i></Link></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="container">
            <div className="row g-4">
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/control-feels-like.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                Control That Adapts
                            </h6>
                            <p className="mb-0">
                                Simply install and personalize your streaming setup to match your business demands.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/stream-from-any.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                Stream From Any Spot
                            </h6>
                            <p className="mb-0">
                                Live stream your videos anywhere, on any device-no more limits, no more struggle.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/stable-by-design.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                Stable by Design
                            </h6>
                            <p className="mb-0">
                                Stream with our dedicated streaming server for smooth and hassle-free streaming.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>

      <section className="price-plan-section pt-100 pb-100">
        <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
        <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-xl-8">
                          <div className="text-center">
                              <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                              <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> Host the Way You’ve Always Imagined.</h2>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        <PlanList category={'customizedssln'}/>
      </section>

      <section className="simple-box-section pt-100 pb-100">
      <div className="container">
        <div className="row">
            <div className="col-12">
                <div className="card rounded-3 cta-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="card-body px-6 pt-60 pb-60">
                        <div className="row justify-content-center">
                            <div className="col-md-11 col-lg-8 col-xl-8">
                                <div className="text-center">
                                  <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">London Media Core</span>
                                    <h4 className="mb-4">
                                        Stream Smart. Stream From London to the World.
                                    </h4>
                                    <p className="mb-6">
                                      The whole crowd is waiting. You hit play-and nothing loads. Spooky nightmare, right? With the help of our dedicated streaming server London, that’s a reality you’ll never go through. 
                                    </p>
                                    <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-2 btn-height">
                                        <span className="d-inline-block me-1 flex-shrink-0">
                                            <i className="las la-comments"></i>
                                        </span>
                                        <span className="btn-arrow__text">
                                            +91-7737300013
                                            <span className="btn-arrow__icon">
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </span>
                                        </span>
                                    </Link>
                                    <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded ms-sm-2 mt-sm-0 mt-4 open-live-chat btn-height">
                                        <span className="d-inline-block me-1 flex-shrink-0">
                                            <i className="las la-comments"></i>
                                        </span>
                                        <span className="btn-arrow__text">
                                            Talk to an Expert
                                            <span className="btn-arrow__icon">
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </span>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </section>

    <section className="bg-dark pt-100 pb-100 position-relative allfeatures-wrapper">
        <img src="images/service_16_shape_2.png" alt="Image" className="img-fluid position-absolute start-0 bottom-0 pattern-bg-img"></img>
        <div className="pb-40">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-12 col-lg-10 col-xl-7">
                        <div className="text-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                          <span className="section-title-dark style-bg fadeInUp">Stream-Ready Features</span>
                            <h2 className="text-white">
                                All You Wish For: Get Them With Our Live Streaming Server
                            </h2>
                            <p className="mb-0 text-white max-text-52 mx-auto text-opacity-75">
                                More than blazing-fast speed-get all premium features that boost your whole stream. Our dedicated streaming server London offers the
                                power, scalability, and extras you need to stay ahead.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AllFeatures />
      </section>

      <section className="pt-100 pb-100">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>Stream Prime UK
                        </small>
                    </div>
                    <div className="text-center mb-8">
                        <h2 className="text-dark mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">What’s Inside Our Plans? Everything You Wish For!</h2>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Stream-Ready Servers</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">01</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/stream-from-any.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Stream fast with an easy-to-use UI, CLI, & API-no challenging setup needed.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Live Means Live Here</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">02</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/live-in-hours.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Stream in real time-no issue, no glitch. Featured by our streaming server London.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">WebRTC at Full Scale</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">03</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/webRTC-at-full.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Auto-scale with comfort & stream at 0.05s latency-with our live streaming server.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Threats Entry: Prohibited</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">04</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/cyber-security-strategy.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Shield protects your Streaming Server London-reduce risks in under 10 seconds.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Audio/Video-Perfected</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">05</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/audio-video.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Create seamless, advanced calling features using our easy-to-integrate SDKs</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Instant Cam Access</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">06</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/instant-cam.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Smoothly stream ONVIF IP cameras along with audio to your website or app using AMS.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section className="pb-100">
      <div className="">
        <div className="container">
          <div className="card cta-wrapper-one domain-container-inner rounded-3">
            <div className="card-body p-md-6 p-xl-10 special-box-padding">
              <div className="g-4 align-items-center">
                <div className="text-center">
                <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Fastlane London</small>
                  <h5 className="mt-3 mb-4">
                      Ever Think About Why Our Streaming Server London Never Lags?
                  </h5>
                  <p>
                      Our streaming server in London offers blazing-fast speeds, stable connections, and powerful security, ensuring that your content reaches your target audience without glitches or issues. Our servers are ideal for streaming rich media online, providing a user-friendly experience across all devices.
                      While implementing streaming solutions on different hardware platforms can be challenging, we simplify the process
                      with a pre-installed and fully configured audio/video streaming server in London.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 pt-80">
              <img src="images/behind-the-scene-streaming.webp" alt="image" className="img-fluid" />
          </div>
        </div>
      </div>
    </section>

    <section className="pb-100">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>Stream Anytime, Anywhere
                        </small>
                    </div>
                    <div className="text-center mb-8">
                        <h2 className="text-dark mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Streamers From Different Corners of the World Trust This Setup</h2>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Setup? On Us.</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">01</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/all-setup.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Simply, install a live streaming server London with just one click. No extra cost.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">No Wait, Just Help</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">02</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/no-wait-just.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Crash at day or night, either 2 AM or 2 PM; your 24/7 expert support is just a message away.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Scale in Seconds</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">03</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/stable-by-design.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Scale your live video streams to meet all global-level needs-fast and reliably.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Your Safety, First</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">04</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/your-safety-first.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Your site safety is never an option with us-our streaming servers maintain it 24/7.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Online. Always.</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">05</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/online-always.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">With the presence of 99.9% uptime, your online presence never goes down with us.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Never Lose a File</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">06</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/never-lose.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">We simply back it up constantly on time, so you never lose important files or any other data.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </section>

        <div className="pb-100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-10 col-lg-8 col-xl-6">
                        <div className="text-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Our Server: Pulse of London</small>
                            <h2 className="mb-4">
                                From Zero to Millions: Streaming Server London
                            </h2>
                            <p className="mb-8 max-text-52 mx-auto sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Stream Like a Royal in the Square Mile
                            </p>
                            <div className="d-flex flex-wrap justify-content-center align-items-center gap-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                <Link to="#" onClick={handlePlanClick} className="btn btn-lg btn-primary btn-arrow fs-14 fw-medium rounded btn-height">
                                    <span className="d-inline-block me-1 flex-shrink-0">
                                        <i className="las la-comment-dots"></i>
                                    </span>
                                    <span className="btn-arrow__text">
                                        Get Started
                                        <span className="btn-arrow__icon">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                    </span>
                                </Link>
                                <Link to="#" className="btn btn-lg btn-dark btn-arrow fs-14 fw-medium rounded open-live-chat btn-height">
                                    <span className="d-inline-block me-1 flex-shrink-0">
                                        <i className="las la-comment-dots"></i>
                                    </span>
                                    <span className="btn-arrow__text">
                                        Talk to an Expert
                                        <span className="btn-arrow__icon">
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <StreamingServerVideo />
    </>
  );
}
